const CATALOGUE = [
    // The six from spec/21 §7.
    {
        id: 'gateway-reconnect-storm',
        title: 'Gateway reconnect storm',
        forSignal: 'Every station reconnecting at once — after a deploy, a load-balancer event, or a network blip.',
        namedInSpec: true,
    },
    {
        id: 'postgres-failover',
        title: 'Postgres failover',
        forSignal: 'The managed database has promoted a standby, or is about to.',
        namedInSpec: true,
    },
    {
        id: 'valkey-loss',
        title: 'Valkey loss',
        forSignal: 'Valkey is unreachable or has been wiped. Presence, caches and rate limits are gone.',
        namedInSpec: true,
    },
    {
        id: 'payment-provider-outage',
        title: 'Payment provider outage',
        forSignal: 'Payments are failing or settling late and the cause is on the provider side.',
        namedInSpec: true,
    },
    {
        id: 'bad-client-release',
        title: 'A bad client release',
        forSignal: 'Errors, crashes or a station fleet going quiet, correlated with a version.',
        namedInSpec: true,
    },
    {
        id: 'security-incident',
        title: 'A suspected security incident',
        forSignal: 'Anything that suggests a credential, a device key or a lease-signing key is in the wrong ' +
            'hands — including bumping the cookie-cache version and mass key/device revocation.',
        namedInSpec: true,
    },
    // The rest, one per alert that the six above do not cover.
    {
        id: 'api-availability',
        title: 'API availability',
        forSignal: '/v1 is returning 5xx, or is not answering at all.',
        namedInSpec: false,
    },
    {
        id: 'api-latency',
        title: 'Degraded API latency',
        forSignal: 'The latency SLO is being missed but requests are still succeeding.',
        namedInSpec: false,
    },
    {
        id: 'elevated-errors',
        title: 'Elevated error rate',
        forSignal: 'More errors than usual, without an outage.',
        namedInSpec: false,
    },
    {
        id: 'outbox-backlog',
        title: 'Outbox backlog or dead letters',
        forSignal: 'Domain events are not being delivered: the backlog is growing, or a delivery has died.',
        namedInSpec: false,
    },
    {
        id: 'auth-outage',
        title: 'Auth outage',
        forSignal: 'Sign-ins are failing across methods. Nobody can start a session.',
        namedInSpec: false,
    },
    {
        id: 'mass-station-offline',
        title: 'Mass station offline',
        forSignal: 'A large share of the fleet, or a whole venue, has lost its socket.',
        namedInSpec: false,
    },
    {
        id: 'ledger-integrity',
        title: 'Ledger integrity failure',
        forSignal: 'Debits and credits disagree, or the integrity job has stopped running.',
        namedInSpec: false,
    },
    {
        id: 'settlement-failure',
        title: 'Settlement failure',
        forSignal: 'Captured money is not settling to organisation payout accounts.',
        namedInSpec: false,
    },
    {
        id: 'cost-anomaly',
        title: 'Cost anomaly',
        forSignal: 'OTP, notification, log or trace volume has stepped up without a matching step in traffic.',
        namedInSpec: false,
    },
    {
        id: 'business-anomaly',
        title: 'Revenue or session anomaly',
        forSignal: 'Takings or sessions are far from what this venue does at this hour on this day.',
        namedInSpec: false,
    },
    {
        id: 'cash-variance',
        title: 'Cash variance over threshold',
        forSignal: 'A blind count came out too far from expected at shift close.',
        namedInSpec: false,
    },
];
export const RUNBOOKS = CATALOGUE;
const BY_ID = new Map(RUNBOOKS.map((runbook) => [runbook.id, runbook]));
export function findRunbook(id) {
    return BY_ID.get(id);
}
/** Where the prose lives, relative to the repository root. The generator checks the file is there. */
export function runbookPath(id) {
    return `infra/observability/runbooks/${id}.md`;
}
//# sourceMappingURL=runbooks.js.map